// src/index.js
import './index.css';
import './components/common/PwaSheetModal.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { isPwaApp } from './config/appMode';
import { syncPwaDocumentUi } from './setupAppMode';
import { getModalPortalRoot, getPwaChromePortalRoot } from './utils/modalPortal';

getModalPortalRoot();

if (isPwaApp) {
  getPwaChromePortalRoot();
  syncPwaDocumentUi();
  import('./components/PWAInstallPrompt.css');
  import('./components/PwaBottomNav.css');
  import('./components/PwaLandscapeCompact.css');

  if (process.env.NODE_ENV !== 'production' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
